import { AuthService, type HttpClient } from '@vestigas/auth';
import ky from 'ky';

/**
 * Simple ky instance for token refresh only.
 * Does NOT use auth interceptors (to avoid circular dependency).
 * The main API ky instances in kyClient.ts will use this auth service.
 */
const tokenRefreshClient = ky.create({
  timeout: 10_000,
  retry: {
    limit: 2,
    methods: ['post'],
    statusCodes: [408, 413, 429, 500, 502, 503, 504],
  },
});

// Wrap ky instance for HttpClient interface
const httpClient: HttpClient = {
  post: async <T = unknown>(
    url: string,
    data?: URLSearchParams | string | Record<string, unknown>,
    config?: Record<string, unknown>,
  ): Promise<{ data: T }> => {
    const response = await tokenRefreshClient
      .post(url, {
        body: data as BodyInit,
        ...config,
      })
      .json<T>();
    return { data: response };
  },
};

const authService = new AuthService(
  {
    authority: 'https://login.vestigas.com/auth/realms/vestigas/',
    clientId: 'mobile_apps',
    redirectUri: globalThis.location.href,
    scope: 'openid offline_access',
  },
  httpClient,
);

export default authService;
